function initmuspell() { 
  if (typeof Swiper !== 'undefined') {
    const existingSwiper = document.querySelector('.m-upsell-slider')?.swiper;
    if (existingSwiper) {
      existingSwiper.destroy(true, true);
    }
    
    new Swiper('.m-upsell-slider', {
      slidesPerView: 1,
      loop: true,
      spaceBetween: 24,
      navigation: {
        nextEl: '.m-upsell-next',
        prevEl: '.m-upsell-prev',
      },
      breakpoints: {
        768: { slidesPerView: 1 },
        1024: { slidesPerView: 1 },
      },
    });
  }
  document.querySelectorAll('.m-upsell-btn').forEach(button => {
    const newButton = button.cloneNode(true);
    button.parentNode.replaceChild(newButton, button);
  });
  document.querySelectorAll('.m-upsell-btn').forEach(button => {
    button.addEventListener('click', async () => {
      const id = button.getAttribute('data-variant-id');
      if (!id) return;
      const spinner = button.querySelector('.loading__spinner');
      const buttonText = button.querySelector('.m-upsel-button-text');
      button.disabled = true;
      if (spinner) spinner.classList.remove('hidden');
      if (buttonText) buttonText.classList.add('hidden');

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          },
          body: JSON.stringify({ id: Number(id), quantity: 1 }),
          credentials: 'same-origin',
        });
        if (!response.ok) throw new Error('Add to cart failed');
        const sectionsResponse = await fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble');
        const sections = await sectionsResponse.json();
        if (sections['cart-drawer']) {
          const html = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
          const newDrawer = html.querySelector('cart-drawer');
          const currentDrawer = document.querySelector('cart-drawer');
          
          if (currentDrawer && newDrawer) {
            currentDrawer.innerHTML = newDrawer.innerHTML;
          }
        }
        if (sections['cart-icon-bubble']) {
          const html = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
          const newBubble = html.querySelector('.cart-count-bubble');
          const currentBubble = document.querySelector('.cart-count-bubble');
          
          if (currentBubble && newBubble) {
            currentBubble.replaceWith(newBubble);
          }
        }
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          cartDrawer.open();
        }
        if (spinner) spinner.classList.add('hidden');
        if (buttonText) buttonText.classList.remove('hidden');
        button.disabled = false;
        setTimeout(() => {
          initmuspell();
        }, 300);
      } catch (error) {
        console.error('Upsell Add Error:', error);
        if (spinner) spinner.classList.add('hidden');
        if (buttonText) buttonText.classList.remove('hidden');
        button.disabled = false;
      }
    });
  });
}

function gridimage(productId, img, clickedElement) {
  var mainDivSelector = '.mcard-product-' + productId;
  var colorBoxSelector = mainDivSelector + ' .mgrid-color-box';
  var elements = document.querySelectorAll(colorBoxSelector);
  elements.forEach(function(element) {
    element.classList.remove('colorActive');
  });
  clickedElement.classList.add('colorActive');
  var imageSelector = mainDivSelector + ' .mcard-image-' + productId;
  var element = document.querySelector(imageSelector);
  if (element) {
    element.src = img;
  } 
}



mnewinitslide();

$(document).on('shopify:section:load', function(event) {
 mnewinitslide();
});
$(document).on('shopify:section:unload', function(event) {
  $('.hellslider').slick('unslick');
});
function mnewinitslide() {
    $('.hellslider').slick({
    infinite: true,
    speed: 400,
    autoplay: true,
    slidesToShow: 3,
    pauseOnHover: false,
    slidesToScroll: 3,
    arrows: false,
    centerMode: true,
    centerPadding: '0px',
    adaptiveHeight: true,
    autoplaySpeed: 5000,
    dots: true,
    responsive: [ 
      {
        breakpoint: 991,
        settings: {
         centerMode: false,
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },      
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false
        }
      }
    ]
  });
}



function mobileOnlySlider() {
    $('.cstm-services').slick({
      dots: true,
      infinite: true,
      speed: 300,
      arrows: false,
      slidesToShow: 1,
      adaptiveHeight: true
    });
  }

  function destroySlider() {
    if ($('.cstm-services').hasClass('slick-initialized')) {
      $('.cstm-services').slick('unslick');
    }
  }

  // Initialize slider on mobile
  if (window.innerWidth < 768) {
    mobileOnlySlider();
  }

  // Handle window resize
  $(window).resize(function () {
    if (window.innerWidth < 768) {
      if (!$('.cstm-services').hasClass('slick-initialized')) {
        mobileOnlySlider();
      }
    } else {
      destroySlider();
    }
  });
function isElementMovedUpAndOutOfViewport(el) {
  var rect = el.getBoundingClientRect();
  return (
      rect.bottom <= 0 &&
      rect.top < window.innerHeight
  );
}

function isElementInViewport(el) {
  var rect = el.getBoundingClientRect();
  return (
      rect.top < window.innerHeight &&
      rect.bottom > 0
  );
}

function checkVisibility() {
  let ogPaymentElement = document.querySelector(".og-payment");
  let stickyatc = document.querySelector("#cstm-sticky-bar");
  let footer = document.querySelector("footer");

  if (isElementInViewport(footer)) {
      stickyatc.classList.remove("mvisible");
      return; 
  }

  if (isElementMovedUpAndOutOfViewport(ogPaymentElement)) {
      stickyatc.classList.add("mvisible");
  } else {
      stickyatc.classList.remove("mvisible");
  }
}  
  let checkstickyatc = document.querySelector("#cstm-sticky-bar");

  if (checkstickyatc){
    window.addEventListener("scroll", checkVisibility);
    window.addEventListener("resize", checkVisibility); 
    checkVisibility();
  }

 function updatePriceNimageSticky()
{
  var getData = document.querySelector('div#cstm-sticky-bar select.matc-variantsSelecter').selectedOptions[0].dataset;
  var image = getData.image;
  var price = getData.price;
  var cprice = getData.cprice;
  
if(document.querySelector('div#cstm-sticky-bar img.sticky-bar-thumb-thumb'))
document.querySelector('div#cstm-sticky-bar img.sticky-bar-thumb-thumb').src= image;
  
if(document.querySelector('div#cstm-sticky-bar span.matc-price'))
document.querySelector('div#cstm-sticky-bar span.matc-price').innerHTML= price;
 
if(document.querySelector('div#cstm-sticky-bar span.matc-compare-price'))
document.querySelector('div#cstm-sticky-bar span.matc-compare-price').innerHTML= cprice;
}

function addToCartStickyBar()
{
$.ajax({
type: 'POST',
url: '/cart/add.js',
data: {
quantity: parseInt(document.querySelector('.matc-form input[name="quantity"]').value),
id: parseInt(document.querySelector('select#matc-variantsSelect').value)
},
dataType: 'json', 
success: function (data) { 
  var product = data;
    document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        detail: {
          product: product,
          addToCartBtn: this.addToCart
        }
       }));
      setTimeout(function() {
      document.getElementById("cstm-sticky-bar").classList.remove("mvisible");
}, 1000);
} 
});
}

function mreviewSliderSwiper() {
    var swiper = new Swiper(".M-review-slider", {
      spaceBetween: 30,
      autoplay: true,
      pagination: {
        el: ".swiper-pagination",
        type: "progressbar",
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        348: {
          centeredSlides: true,
          slidesPerView: 1.2,
          spaceBetween: 20,
          centeredSlidesBounds: true,
        },
        640: {
          slidesPerView: 2.2,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 2.6,
          spaceBetween: 30,
        },
        1024: {
          slidesPerView: 3.25,
          spaceBetween: 30,
        }
      }
    });
  }

function updateShippingDate() {
const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const months = ["January", "February", "March", "April", "May", "June", "July", 
                "August", "September", "October", "November", "December"];
    const now = new Date();
    const tomorrow = new Date(now);
    tomorrow.setDate(now.getDate() + 1);
    
    const formattedDate = `${daysOfWeek[tomorrow.getDay()]}, ${tomorrow.getDate()} ${months[tomorrow.getMonth()]}`;
    document.getElementById('mshipping-date').innerText = formattedDate;
    
    const msUntilMidnight = new Date(now.setHours(24, 0, 0, 0)) - now;
    setTimeout(() => {
        updateShippingDate();
        setInterval(updateShippingDate, 24 * 60 * 60 * 1000);
    }, msUntilMidnight);
}

function toggleMActiveClass() {
    var elements = document.getElementsByClassName("m-textwrap");
    for (var i = 0; i < elements.length; i++) {
        elements[i].classList.toggle("mactive");
    }
}

function startInterval() {
    // Execute immediately
    toggleMActiveClass();

    // Set up the interval
    setInterval(function() {
        toggleMActiveClass();
    }, 3000);
}

window.onload = startInterval;

function initializeSwiper() {
    var swiper = new Swiper(".M-images-slider", {
      spaceBetween: 20,
      autoplay: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        348: {
          centeredSlides: true,
          slidesPerView: 1,
          spaceBetween: 20,
          centeredSlidesBounds: true,
        },
        640: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 30,
        }
      }
    });
  }

function randomInventoryNumber(min, max){
  const randomNum = Math.floor(Math.random() * (max - min + 1)) + min;
  const mvistrElement = document.getElementById('mrandomInven');
  mvistrElement.textContent = randomNum;
}
  

  
function initslide() {
  $('.M-trustpilot-slider-home').slick({
    infinite: true,
    speed: 600,
    slidesToShow: 3,
    slidesToScroll: 3,
    centerMode: true,
    centerPadding: '200px',
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: true,
    prevArrow:"<button type='button' class='slick-prev Mtp-left'><svg xmlns='http://www.w3.org/2000/svg' height='1em' viewBox='0 0 320 512'><path d='M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z'/></svg></button>",
    nextArrow:"<button type='button' class='slick-next Mtp-right'><svg xmlns='http://www.w3.org/2000/svg' height='1em' viewBox='0 0 320 512'><path d='M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z'/></svg></button>",
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          centerMode: true,
          centerPadding: '100px',
          arrows: false,
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 575,
        settings: {
          centerMode: true,
          arrows: false,
          centerPadding: '50px',
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 400,
        settings: {
          centerMode: true,
          arrows: false,
          centerPadding: '10px',
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
}
function updateCounter(id, min, max, int) {
  let counter = document.getElementById(id);
  let count = parseInt(localStorage.getItem("count")) || parseInt(min);
  min = parseInt(min);
  max = parseInt(max);
  int = parseInt(int);

  function updateCount() {
    let randomNum = Math.random() < 0.5 ? Math.floor(Math.random() * 5) + 1 : Math.floor(Math.random() * 10) + 1;
    let randomSign = Math.random() < 0.7 ? 1 : -1;
    count += randomNum * randomSign;
    count = Math.max(min, Math.min(max, count));
    counter.textContent = count;
    localStorage.setItem("count", count);
  }

  setInterval(updateCount, int);
  updateCount();
}
function initializeSlider(){
var swiper = new Swiper(".mySwiper", {
  slidesPerView: 3,
  spaceBetween: 48,  
  scrollbar: {
    el: ".swiper-scrollbar",
  },
    breakpoints: {
    1024: {
      slidesPerView: 3,
      spaceBetween: 30,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 30,
    },
    569: {
      slidesPerView: 1.3,
      spaceBetween: 20,
    },
    348: {
      slidesPerView: 1,
      spaceBetween: 20,
    },
    0: {
      slidesPerView: 1,
      spaceBetween: 20,
    },
  }

});
}  

$('.M-trustpilot-slider').slick({
   infinite: true,
   slidesToShow: 2,
   slidesToScroll: 1,
   autoplay: true,
   autoplaySpeed: 3000,
     prevArrow:"<button type='button' class='slick-prev Mtp-left'><svg xmlns='http://www.w3.org/2000/svg' height='1em' viewBox='0 0 320 512'><path d='M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z'/></svg></button>",
    nextArrow:"<button type='button' class='slick-next Mtp-right'><svg xmlns='http://www.w3.org/2000/svg' height='1em' viewBox='0 0 320 512'><path d='M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z'/></svg></button>",
  responsive: [
   {
      breakpoint: 900,
      settings: {
        arrows: true,
        centerPadding: '40px',
        slidesToShow: 1
      }
   },
   {
      breakpoint: 600,
      settings: {
        arrows: true,
        centerPadding: '40px',
        slidesToShow: 1
      }
   }
  ]
  });
var homeSwiper = new Swiper(".m-quotes-swiper", {
  fadeEffect: { crossFade: true },
  virtualTranslate: true,
  speed: 1000, 
  slidersPerView: 1,
  effect: "fade",
  navigation: {
    nextEl: ".m-quotes-next",
    prevEl: ".m-quotes-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },  
});

var swiper = new Swiper(".m-usps-swiper", {
  slidesPerView: 1, 
  spaceBetween: 30, 
  breakpoints: {
    1000: {
      slidesPerView: 3,
      spaceBetween: 50,
    }
  }
});


aggiornaData();
  let timerDiv = document.getElementById("mtime");
  if (timerDiv){
  const targetTime = new Date().getTime() + 5 * 60 * 1000;
  function updateTimer() {
      const currentTime = new Date().getTime();
      const timeRemaining = targetTime - currentTime;
      if (timeRemaining <= 0) {
          document.getElementById("mtime").textContent = "00:00";
      } else {
          const minutes = Math.floor((timeRemaining / 1000 / 60) % 60);
          const seconds = Math.floor((timeRemaining / 1000) % 60);
          document.getElementById("mtime").textContent = `${minutes}m ${seconds}s`;
      }
  }
  setInterval(updateTimer, 1000);
        document.addEventListener("DOMContentLoaded", function() {
        updateTimer();
      });
  }



